import { identityAccountId, IdentityAccountId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountDeleteRequestDTORaw) {
    JsonSchemaValidator.validate(IAMAccountDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId"],
      properties: {
        accountId: identityAccountId
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountDeleteRequestDTORaw {
  accountId: IdentityAccountId;
}
